import Vue from 'vue';
import Vuex from 'vuex';
import audit from './modules/audit.module';
import createPersistedState from 'vuex-persistedstate';
import profile from './modules/profile.module';
import settings from './modules/settings.module';
import users from './modules/users.module';
import tasks from './modules/tasks.module';
import snackbars from './modules/snackbars.module';
import orders from './modules/orders.module';
import shippings from './modules/shippings.module';
import shippings_monitor from './modules/shippings_monitor.module';
import giftcard from './modules/giftcard.module';
import categories from './modules/categories.module';
import items from './modules/items.module';
import brands from './modules/brands.module';
import socket from './modules/socket.module';
import measures from './modules/measures.module';
import currencies from './modules/currencies.module';
import languages from './modules/languages.module';
import suppliers from './modules/suppliers.module';
import statusorders from './modules/statusorders.module';
import paymentmethods from './modules/paymentmethods.module';
import listings from './modules/listings.module';
import customers from './modules/customers.module';
import agents from './modules/agents.module';
import graphs from './modules/graphs.module';
import dashboard from './modules/dashboard.module';
import orderboard from './modules/orderboard.module';
import packagings from './modules/packagings.module';
import tags from './modules/tags.module';
import barcode from './modules/barcode.module';
import qrupload from './modules/qrupload.module';
import imagestudio from './modules/imagestudio.module';
import qrscan from './modules/qrscan.module';
import sku from './modules/sku.module';
import notify from './modules/notify.module';
import amazonform from './modules/amazonform.module';
import amazon from './modules/amazon.module';
import ebay from './modules/ebay.module';
import packingLists from './modules/packinglists.store';
import dispatchOrders from './modules/dispatch-orders.module';
import fattureincloud from './modules/fattureincloud.module';
import messages from './modules/messages.module';
import documents from './modules/documents.module';
import services from './modules/services.module';
import pages from './modules/pages.module';
import inventories from './modules/inventories.module';
import ddts from './modules/ddts.module';
import fattureelettroniche from './modules/fattureelettroniche.module';
import warehouse from './modules/warehouse.module';
import cart from './modules/cart.module';
import permissions from './modules/permissions.module';
import variants from './modules/variants.module';
import attributes from './modules/attributes.module';
import shippingmethods from './modules/shippingmethods.module';
import shippingcosts from './modules/shippingcosts.module';
import googlemaps from './modules/googlemaps.module';
import emailtemplate from './modules/emailtemplate.module';
import coupon from './modules/coupon.module';
import couponcode from './modules/couponcode.module';
import newsletters from './modules/newsletters.module';
import offers from './modules/offers.module';
import flyers from './modules/flyers.module';
import socialposts from './modules/socialposts.module';
import alerts from './modules/alerts.module';
import reviews from './modules/reviews.module';
import redirects from './modules/redirects.module';
import searchlogs from './modules/searchlogs.module';
import webvitals from './modules/webvitals.module';
import serverhealth from './modules/serverhealth.module';
import sitehealth from './modules/sitehealth.module';
import catalogcheck from './modules/catalogcheck.module';
import finance from './modules/finance.module';
import ads from './modules/ads.module';
import insights from './modules/insights.module';
import communications from './modules/communication.module';
import returnstore from './modules/returns.module';
import stats from './modules/stats.module';
import blog from './modules/blog.module';
import assistant from './modules/assistant.module';
import whatsapp from './modules/whatsapp.module';
import cartend from './modules/cartend.module';
import banners from './modules/banners.module';
import partners from './modules/partners.module';
import partnerprogram from './modules/partnerprogram.module';
import affiliateprogram from './modules/affiliateprogram.module';
import integrations from './modules/integrations.module';
import promoslides from './modules/promoslides.module';
import documentations from './modules/documentations.module';
import calendars from './modules/calendars.module';
import tickets from './modules/tickets.module';
import downloads from './modules/downloads.module';
import marketplaceCatalog from './modules/marketplaceCatalog.module';
import marketplaceUnmatched from './modules/marketplaceUnmatched.module';
import amazonPrice from './modules/amazonPrice.module';
import ebayPrice from './modules/ebayPrice.module';
import marketplaceRules from './modules/marketplaceRules.module';
import repricing from './modules/repricing.module';
import profiles from './modules/profiles.module';
import affiliates from './modules/affiliates.module';
import payments from './modules/payments.module';
import itemrewrite from './modules/itemrewrite.module';
import searchconsole from './modules/searchconsole.module';
import merchantinsights from './modules/merchantinsights.module';
import googletrends from './modules/googletrends.module';
import seoanalysis from './modules/seoanalysis.module';
import keywordideas from './modules/keywordideas.module';
import brandimport from './modules/brandimport.module';
import competitor from './modules/competitor.module';

//import database from './modules/database.module';

Vue.use(Vuex);
export default new Vuex.Store({
	//   plugins: [createPersistedState()],
	modules: {
		downloads,
		marketplaceCatalog,
		marketplaceUnmatched,
		amazonPrice,
		ebayPrice,
		marketplaceRules,
		repricing,
		settings,
		profile,
		profiles,
		affiliates,
		payments,
		users,
		tasks,
		snackbars,
		orders,
		categories,
		items,
		socket,
		measures,
		currencies,
		languages,
		brands,
		suppliers,
		statusorders,
		paymentmethods,
		listings,
		customers,
		agents,
		graphs,
		dashboard,
		orderboard,
		shippings,
		shippings_monitor,
		giftcard,
		packagings,
		tags,
		barcode,
		qrupload,
		imagestudio,
		qrscan,
		itemrewrite,
		searchconsole,
		merchantinsights,
		googletrends,
		seoanalysis,
		keywordideas,
		brandimport,
		competitor,
		sku,
		notify,
		amazonform,
		amazon,
		ebay,
		packingLists,
		dispatchOrders,
		fattureincloud,
		messages,
		documents,
		pages,
		services,
		inventories,
		ddts,
		fattureelettroniche,
		warehouse,
		cart,
		permissions,
		variants,
		attributes,
		shippingmethods,
		shippingcosts,
		googlemaps,
		emailtemplate,
		coupon,
		couponcode,
		newsletters,
		offers,
		flyers,
		socialposts,
		alerts,
		reviews,
		redirects,
		searchlogs,
		webvitals,
		serverhealth,
		sitehealth,
		catalogcheck,
		insights,
		finance,
		ads,
		communications,
		returnstore,
		stats,
		blog,
		assistant,
		whatsapp,
		cartend,
		banners,
		partners,
		partnerprogram,
		affiliateprogram,
		integrations,
		promoslides,
		documentations,
		calendars,
		audit,
		tickets,
	},
});
